import React, { useCallback } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'reactstrap';

import CustomerSearch from '../../../CustomerSearch';
import Reading from '../Reading/Reading';
import { changeOfTenancySchema, changeOfTenancyUISchema } from '../../schemas/changeOfTenancySchema';
import { useProcessForm } from '../../hooks/useProcessForm';

const ChangeOfTenancyForm = ({ onClose }) => {
  const { formContext, updateFormContext, isLoading } = useProcessForm();

  const handleSubmit = useCallback(({ formData }) => {
    // TODO: Implement actual form submission logic
    // eslint-disable-next-line no-console
    console.log(formData);
  }, []);

  const handleChange = useCallback(
    ({ formData }) => {
      // eslint-disable-next-line no-console
      console.log('formData', formData);
      updateFormContext(formData);
    },
    [updateFormContext]
  );

  const loadingIcon = isLoading ? (
    <span>
      <i className='fa fa-circle-o-notch fa-spin'></i>{' '}
    </span>
  ) : null;

  const uiSchemaWithWidgets = {
    ...changeOfTenancyUISchema,
    businessPartner: {
      ...changeOfTenancyUISchema.businessPartner,
      'ui:widget': (props) => <CustomerSearch {...props} />,
    },
  };

  return (
    <Form
      schema={changeOfTenancySchema}
      uiSchema={uiSchemaWithWidgets}
      fields={{ readingField: Reading }}
      formContext={formContext}
      formData={formContext}
      onSubmit={handleSubmit}
      onChange={handleChange}
    >
      <div>
        <Button type='submit' disabled={isLoading} color='primary'>
          {loadingIcon}Start Process
        </Button>
        &nbsp;&nbsp;&nbsp;
        <Button type='button' onClick={onClose}>
          Cancel
        </Button>
      </div>
    </Form>
  );
};

export default ChangeOfTenancyForm;
